// src/components/pos/CategoryFilter.js
import React from 'react';
import { Box, Chip } from '@mui/material';

const CategoryFilter = ({ categories, selectedCategory, onSelectCategory }) => {
    return (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
            <Chip
                label="Todas"
                onClick={() => onSelectCategory(null)}
                color={selectedCategory === null ? 'primary' : 'default'}
            />
            
            {/* --- VALIDACIÓN DE SEGURIDAD --- */}
            {/* Solo intentamos mapear si 'categories' es realmente un array */}
            {Array.isArray(categories) && categories.map((category) => (
                <Chip
                    key={category.id}
                    label={category.name}
                    onClick={() => onSelectCategory(category.name)}
                    color={selectedCategory === category.name ? 'primary' : 'default'}
                />
            ))}
        </Box>
    );
};

export default CategoryFilter;